import "datatables.net";
import sislogUserGlobals from "./../../UserGlobals";
import {ColumnDefinition, TableColumn} from "./ColumnDefinitions";
import numbro from "numbro";

export class NumberColumn implements DataTables.ColumnDefsSettings, TableColumn {
    public className = "c-datatable__number-column-cell";
    public targets: number;
    public property: string;
    public name: string;
    public decimals: number = null;
    public orderable = true;
    public optionsFormat = {} as any;
    public definition: ColumnDefinition;

    constructor(column: number, definition: NumberColumDefinition) {
        this.targets = column;
        this.property = definition.property;
        this.name = this.property;
        this.decimals = definition.decimals;
        this.optionsFormat = {
            thousandSeparated: true,
        };
        if(this.decimals != null && this.decimals != undefined) {
            this.optionsFormat.mantissa = this.decimals;
        }
        numbro.setLanguage(sislogUserGlobals.locale);
        this.orderable = definition.orderable;
        this.definition = definition;
    }

    public render = (data: number, type: string, row: any) => {
        if (data != null && type === "display") {
            return numbro(data).format(this.optionsFormat);
        }
        return data;
    }
}

export interface NumberColumDefinition extends ColumnDefinition {
    decimals?: number;
    orderable?: boolean;
}
